import BaseApiServiceV2 from "./BaseApiServiceV2";

class PropertiesService extends BaseApiServiceV2 {
	/**
	 * @param {String} id
	 * @returns Promise<Object>
	 * @memberof SearchService
	 */

	getPropertyDetailsByID(id: string, filtersQuery?: string) {
		const qs = filtersQuery?.replace(/^\?/, "").trim();
		return this.apiGet(qs ? `/property/${id}?${qs}` : `/property/${id}`);
	}
	getFeauteredProperties(country: string) {
		return this.apiGet(`/property/featured?country=${country}&limit=9&distinctByWorkspace=true`);
	}

	getNearByProperties(latitude: number, longitude: number, recordsLimit: number, filterBy?: string, radius: number = 13, responseType: boolean = false) {
		return this.apiGet(
			`/property/near-by/properties?latitude=${latitude}&longitude=${longitude}&radius=${radius}&recordsLimit=${recordsLimit}&filter=${filterBy}&fullResponse=${responseType}`
		);
	}
	getPropertyListings(id: string) {
		return this.apiGet(
			`/property/property-listings/${id}`
		);
	}

	getPropertiesByWorkspaceID(id: string): Promise<any[]> {
		return this.apiGet(`/property/workspace/${id}`);
	}

	getPropertyDetails(id: string) {
		return this.apiGet(`/property/${id}`);
	}

	// Overload signatures
	geoSearch(keyword: string): Promise<any>;
	geoSearch(params: {
		latitude: number;
		longitude: number;
		page?: number;
		perPage?: number;
		country?: string;
		state?: string;
		city?: string;
		zoom?: number;
		minPrice?: number;
		maxPrice?: number;
		workspaceType?: string;
		minPeople?: number;
		maxPeople?: number;
		sortBy?: string;
		order?: string;
		minLatitude?: number;
		maxLatitude?: number;
		minLongitude?: number;
		maxLongitude?: number;
	}): Promise<any>;

	// Implementation
	geoSearch(keywordOrParams: string | {
		latitude: number;
		longitude: number;
		page?: number;
		perPage?: number;
		country?: string;
		state?: string;
		city?: string;
		zoom?: number;
		minPrice?: number;
		maxPrice?: number;
		workspaceType?: string;
		minPeople?: number;
		maxPeople?: number;
		sortBy?: string;
		order?: string;
		minLatitude?: number;
		maxLatitude?: number;
		minLongitude?: number;
		maxLongitude?: number;
	}) {
		let params: URLSearchParams;

		// Handle string-based keyword (existing logic)
		if (typeof keywordOrParams === 'string') {
			params = new URLSearchParams(keywordOrParams);
		} else {
			// Handle typed params object (new logic)
			params = new URLSearchParams();
			params.set("latitude", String(keywordOrParams.latitude));
			params.set("longitude", String(keywordOrParams.longitude));
			if (keywordOrParams.page) params.set("page", String(keywordOrParams.page));
			if (keywordOrParams.perPage) params.set("perPage", String(keywordOrParams.perPage));
			if (keywordOrParams.country) params.set("country", keywordOrParams.country);
			if (keywordOrParams.state) params.set("state", keywordOrParams.state);
			if (keywordOrParams.city) params.set("city", keywordOrParams.city);
			if (keywordOrParams.zoom) params.set("zoom", String(keywordOrParams.zoom));
			if (keywordOrParams.minPrice !== undefined && keywordOrParams.minPrice !== 0) params.set("minPrice", String(keywordOrParams.minPrice));
			if (keywordOrParams.maxPrice !== undefined && keywordOrParams.maxPrice !== 0) params.set("maxPrice", String(keywordOrParams.maxPrice));
			if (keywordOrParams.workspaceType) params.set("workspaceType", keywordOrParams.workspaceType);
			if (keywordOrParams.minPeople !== undefined && keywordOrParams.minPeople !== 0) params.set("minPeople", String(keywordOrParams.minPeople));
			if (keywordOrParams.maxPeople !== undefined && keywordOrParams.maxPeople !== 0) params.set("maxPeople", String(keywordOrParams.maxPeople));
			if (keywordOrParams.sortBy) params.set("sortBy", keywordOrParams.sortBy);
			if (keywordOrParams.order) params.set("order", keywordOrParams.order);
			if (keywordOrParams.minLatitude !== undefined) params.set("minLatitude", String(keywordOrParams.minLatitude));
			if (keywordOrParams.maxLatitude !== undefined) params.set("maxLatitude", String(keywordOrParams.maxLatitude));
			if (keywordOrParams.minLongitude !== undefined) params.set("minLongitude", String(keywordOrParams.minLongitude));
			if (keywordOrParams.maxLongitude !== undefined) params.set("maxLongitude", String(keywordOrParams.maxLongitude));
		}

		// Sanitize parameters: remove city or state if they are empty, '0', or invalid
		['city', 'state'].forEach(key => {
			const val = params.get(key);
			if (!val || val === '0' || val === 'undefined' || val === 'null' || val === 'All') {
				params.delete(key);
			}
		});

		return this.apiGet(`/property/geo-search?${params.toString()}`);
	}
}
export default new PropertiesService();
